<template><div><h1>VUX V2.5.11 发布日志</h1>
<h2><a href="/zh-CN/components/datetime.html">Datetime</a></h2>
<ul><li>[fix] 修复 :show.sync 设为 false 无效 #1918</li>
<li>[fix] 修复特定情况下月份变化不会触发小时重新渲染的问题</li>
</ul>
<h2><a href="/zh-CN/components/inline-calendar.html">InlineCalendar</a></h2>
<ul><li>[feature] 支持方法 getDates 用于需要获取渲染日期列表的场合</li>
<li>[feature] 支持 less 变量 @calendar-bg-color</li>
</ul>
<h2><a href="/zh-CN/components/popup.html">Popup</a></h2>
<ul><li>[fix] 仅在全局配置 $layout = VIEW_BOX 时用 fixed body 的形式阻止页面滚动 #1893</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.5.11 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.5.11-241.vue?6ecf1cb7